import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import ResponsiveImage from "../../../shared/responsiveimage";
import styles from "./MediaCoverageTeaser.module.scss";
import { NavLink } from "../../../shared/components/Navbar/Navbar";
import { EffektButton } from "../../../shared/components/EffektButton/EffektButton";
import LinkButton from "../../../shared/components/EffektButton/LinkButton";
import { Links } from "../Links/Links";
export const MediaCoverageTeaser: React.FC<{
  title: string;
  coverage: {
    links: {
      link: string;
      link_text: string;
    }[];
    publication_logo: {
      asset: {
        _id: string;
        metadata: {
          lqip: string;
        };
      };
    };
  }[];
  readMoreButton: NavLink;
}> = t0 => {
  const $ = _c(9);
  const {
    coverage,
    readMoreButton
  } = t0;
  let t1;
  if ($[0] !== coverage) {
    t1 = coverage && coverage.map(_temp2);
    $[0] = coverage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.coverageList}>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== readMoreButton) {
    t3 = readMoreButton && <div className={styles.readMore}><Links links={[readMoreButton]} buttons={true} /></div>;
    $[4] = readMoreButton;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className={styles.container}>{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
function _temp(link, linkIndex) {
  return <li key={linkIndex}><Link href={link.link} target="_blank" rel="noopener noreferrer"><span>{link.link_text}</span></Link></li>;
}
function _temp2(item, index) {
  return <div key={index} className={styles.coverageItem}><div className={styles.logo}>{item.publication_logo && <ResponsiveImage image={item.publication_logo} layout="fill" sizes="(min-width: 1920px) 399px, (min-width: 1024px) calc(22.5vw - 24px), calc(45vw - 16px)" />}</div><div className={styles.details}><ul className={styles.links}>{item.links && item.links.map(_temp)}</ul></div></div>;
}